import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Field, reduxForm } from "redux-form";

class index extends Component {
  renderField = ({
    input,
    label,
    className,
    placeholder,
    type,
    meta: { touched, error, warning },
  }) => (
    <div>
      <div>
        <input {...input} placeholder={placeholder} type={type} className={className} />
        {touched &&
          ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  renderTextArea = ({ input, className, placeholder, type, meta: { touched, error, warning } }) => (
    <div>
      <div>
        <textarea {...input} placeholder={placeholder} className={className} />
        {touched &&
          ((error && <span style={{ color: "red" }}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    </div>
  );

  render() {
    const { pristine, submitting } = this.props;
    const closeBtn = (
      <button className="close p-3" onClick={this.props.toggle}>
        &times;
      </button>
    );
    return (
      <div>
        <Modal isOpen={this.props.modal} className={this.props.className}>
          <ModalHeader toggle={this.props.toggle} close={closeBtn} className=" pb-0">
            {this.props.title}
          </ModalHeader>
          <ModalBody>
            <form
              autoComplete="off"
              noValidate
              onSubmit={this.props.handleSubmit(this.props.handleSendForm)}
            >
              <div className="form-group mt-2">
                <Field
                  name="name"
                  className="form-control"
                  type="text"
                  component={this.renderField}
                  placeholder="Your name"
                  id="messengerName"
                  value={this.props.name}
                  required
                  //   onChange={event => this.props.changeName(event.target.value)}
                />
              </div>
              <div className="form-group mt-2">
                <Field
                  className="form-control"
                  name="email"
                  type="email"
                  component={this.renderField}
                  placeholder="Your Email"
                  //   onChange={event => this.props.changeEmail(event.target.value)}
                  required
                />
              </div>
              <div className="form-group mt-2">
                <Field
                  className="form-control"
                  name="message"
                  type="textarea"
                  component={this.renderTextArea}
                  placeholder="Write your message"
                  //   onChange={event => this.props.changeMessage(event.target.value)}
                  required
                />
              </div>
              <div className="text-right">
                <Button className="jr-btn" size="md" color="light" onClick={this.props.toggle}>
                  Cancel
                </Button>{" "}
                <Button className="jr-btn  btn-vibo2 " size="md" type="submit">
                  Send
                </Button>
              </div>
            </form>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "You must enter your Name";
  }
  if (!values.email) {
    errors.email = "You must enter your Email";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }
  if (!values.message) {
    errors.message = "You must enter your Message";
  }

  return errors;
};

export default connect(
  ({ business }) => {
    const { modalName: name, modalEmail: email, modalMessage: message } = business;
    return { initialValues: { name, email, message } };
  },
  null,
  null,
  { withRef: true }
)(
  reduxForm({
    form: "message",
    validate,
    touchOnChange: true,
    enableReinitialize: true,
  })(index)
);



// WEBPACK FOOTER //
// ./components/MessageModal/index.js